export class ListIngestionPipelineDeadLettersRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortIngestionPipelineDeadLetterBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelineDeadLettersRequest.attributeTypeMap;
    }
    constructor() {
    }
}
